<script lang="ts">
  import butane_logo from 'branding/butane-wide.png'
  import ButaneTextSvg from './SVGs/ButaneTextSVG.svelte'
  import BurgerSvg from './SVGs/BurgerSVG.svelte'
  import Button from '$lib/components/shadcn/button/button.svelte'
  import { innerWidth } from 'svelte/reactivity/window'
  let className: string = ''
  export let menu: () => void

  export { className as class }
</script>

<div class="topbar {className}">
  <!-- svelte-ignore a11y-invalid-attribute -->
  <a href="/" class="ml-5 h-[33px] w-9 min-[400px]:ml-[23.75px] min-[400px]:w-[140.25px]">
    <img src={butane_logo} alt="Butane Logo" class="hidden min-[400px]:block" />
    <ButaneTextSvg svgStyles="min-[400px]:hidden" />
  </a>

  <div class="ml-auto flex">
    <Button
      variant="ghost"
      class="mr-[8px] flex h-11 w-[121px] items-center justify-center rounded-[100px] bg-steel text-center align-middle font-graphik text-sm"
      href="/app"
    >
      LAUNCH APP
    </Button>
    <Button
      variant="ghost"
      class="mr-[9px] flex h-11 w-12 items-center justify-center rounded-[100px] bg-steel"
      onclick={menu}
      aria-label="Open menu"
    >
      <BurgerSvg svgStyles="h-[15px] w-[18px]" />
    </Button>
  </div>
</div>

<style lang="postcss">
  .topbar {
    @apply fixed left-0 right-0 top-[24px] mx-auto flex min-h-[62px] w-full max-w-[628px] items-center rounded-[100px] border border-steel bg-black;
  }
  @media (max-width: 650px) {
    .topbar {
      @apply mx-[16px] w-auto;
    }
  }
</style>
